import styled, { css } from 'styled-components';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  textarea?: boolean;
  thickness?: string;
  noMargin?: boolean;
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
  margin-top: 1rem;

  ${({ noMargin }) =>
    noMargin &&
    css`
      margin-top: 0;
    `};

  &:focus {
    outline: none;
  }

  label {
    font-size: 0.8rem;
    font-weight: 500;
    background: #fff;
    pointer-events: none;
    overflow: hidden;
    width: auto;
    display: inline-block;
    position: relative;
    top: 10px;
    left: 4px;
    transition: all 0.3s ease-out;
    color: ${({ theme }) => theme.colors.tertiary};
  }

  div {
    position: relative;
    width: 100%;
    font-weight: 500;
    background: ${({ theme }) => theme.colors.tertiary};
    transition: 0.3s;
    border: 2px solid ${({ theme }) => theme.colors.tertiary};
    border-radius: 0.5rem;
    padding: 0 0.9rem 0 0.75rem;
    display: flex;
    align-items: center;

    svg#input-icon {
      color: ${({ theme }) => theme.colors.textSecondary};
      margin-right: 0.75rem;
    }

    ${({ textarea }) =>
      !textarea &&
      css`
        height: 3rem;
      `};

    ${({ textarea }) =>
      textarea &&
      css`
        min-height: 3.5rem;
      `};

    ${({ thickness }) =>
      thickness === 'sm' &&
      css`
        height: 2.75rem;
      `}

    ${props =>
      props.isFocused &&
      css`
        border-color: ${({ theme }) => theme.colors.secondary};

        svg#input-icon {
          color: ${({ theme }) => theme.colors.secondary};
        }
      `}

      ${props =>
      props.isFilled &&
      css`
        border-color: ${({ theme }) => theme.colors.tertiary};
      `}

    input, textarea {
      height: 100%;
      width: 100%;
      border: 0;
      outline: none;
      background: transparent;
      color: ${({ theme }) => theme.colors.textPrimary};
    }

    button {
      background: transparent;
      border: 0;
      position: absolute;
      right: 10px;
      top: 0.5rem;
      font-size: 1.1rem;
      color: ${({ theme }) => theme.colors.textSecondary};
    }
  }
`;

export const Error = styled.span`
  color: #dc3545;
  font-size: 0.8rem;
  padding: 0 4px;
`;
